import React from 'react';
import AboutPageLayout from '../components/AboutPage/AboutPageLayout';

const About: React.FC = () => <AboutPageLayout />;

export default About;
